module.exports = __webpack_public_path__ + "img/flagUsaRound.bc90ea65.png";